import React, { useEffect, useState, forwardRef } from 'react'
import { GetPaymentProviderTransaction } from '../../api/services/pms'
import { onError } from '../shared/messages'
import CardList from './cardList'
import PropTypes from "prop-types";
import { EntityType } from '../shared/constants';

const AuthorizationsList = forwardRef(({ reservation, hotelid, newtoken, header, footer, filterUsed, onLoadListFinished, showAllRelatedCards, is3DS, ...rest }, ref) => {
    const [filterAuthorizations, setFilterAuthorizations] = useState([]);
    const [authorizations, setAuthorizations] = useState([]);
    const [selectedId, setSelectedId] = useState();
    const cvvInputRef = ref;

    hotelid = reservation ? reservation.HotelId : hotelid;
    const reservationId = reservation ? reservation.Id: null;
    const reservationEntity = reservation?.entities?.find?.(
      (e) => e.EntityTypeId === EntityType.Reservation
    );

    const derivedEntityId = showAllRelatedCards
      ? reservation.GuestId
      : reservationEntity?.EntityId || reservation.Id || reservation.FolioId;

    const derivedEntityType = showAllRelatedCards
      ? EntityType.Guest
      : reservationEntity?.EntityId || reservation.Id
      ? EntityType.Reservation
      : EntityType.Folio;

    // implement authorizations filter 
    const calcFilterAuthorizations = (authorizations) => {
         let authorizationsFilter = authorizations;
         if(filterUsed) {
             authorizationsFilter = authorizations.filter(x=> x.UsedAmount === null);
         }

         if(is3DS) {
             authorizationsFilter = authorizations.filter(x=> x.IsSecurity);
         }

         setFilterAuthorizations(authorizationsFilter);

         if(onLoadListFinished){
             const noOfItems = authorizationsFilter.length;
             onLoadListFinished("SavedAuthorizations", noOfItems);
         }
    }

    const reload = async () => {
        try {
            const authorizations = await GetPaymentProviderTransaction({
              HotelId: hotelid,
              EntityId: derivedEntityId,
              EntityType: derivedEntityType,
              //Authorizations are first saved on guest and only thereafter added to reservation
              PaymentProviderTransactionTypeId: 2, // AUTHORIZATIONS
              IsValidOnly: filterUsed
            });
            
            setAuthorizations(authorizations);
            calcFilterAuthorizations(authorizations);
        } catch (error) {
            onError(error)
        }
    }

    useEffect(() => {
        if (reservationId) {
            reload();
        }
    }, [reservationId, showAllRelatedCards])

    useEffect(() => {
        calcFilterAuthorizations(authorizations);
    }, [is3DS]);

    useEffect(() => {
        if (newtoken) {
            setAuthorizations([
                ...authorizations,
                newtoken
            ])
        }
    }, [newtoken]);

    // Wrapper functions to manage local selection state (like SavedCardsList)
    const handleSelect = (id) => {
        // Authorization items use Id (not PaymentTokenId), so set it directly
        setSelectedId(id);
        // Pass to parent
        if (rest.onSelect) {
            rest.onSelect(id);
        }
    };

    const handleSelectItem = (item) => {
        if (item) {
            setSelectedId(item.Id);
        }
        if (rest.onSelectItem) {
            rest.onSelectItem(item);
        }
    };

    return filterAuthorizations.length?<div>
        {header}
        <CardList items={filterAuthorizations} authorization hotelId={hotelid} is3DS={is3DS} selected={selectedId} onSelect={handleSelect} onSelectItem={handleSelectItem} guestId={rest.guestId} cvvSession={rest.cvvSession} ref={cvvInputRef} />
        {footer}
    </div>:null
});

AuthorizationsList.displayName = 'AuthorizationsList';
AuthorizationsList.propTypes = {
    reservation: PropTypes.any,
    hotelid: PropTypes.any,
    header: PropTypes.any,
    footer: PropTypes.any,
    newtoken: PropTypes.any,
    filterUsed: PropTypes.bool,
    onLoadListFinished: PropTypes.func,
    showAllRelatedCards: PropTypes.bool,
    is3DS: PropTypes.bool
}

export default AuthorizationsList